import React from "react";
import { makeStyles, Grid } from "@material-ui/core";
import Colors from "shared/color";

const useStyle = makeStyles((theme) => ({
    customeTable: {
      minWidth: '100%',
      "& td":{
        height:"2.5rem"
      },
      "& tbody:nth-child(even)": {
        backgroundColor: Colors["lighterPurple"],
      },
      "& td:first-child":{
          color:"#000 !important",
          textTransform: "capitalize"
      },
      "& td:last-child":{
        wordBreak: "break-all",
      },
    },
  }));
  

export const CustomTableWrapper = (props) => {
    const classes = useStyle();
  return (
    <div className={classes.customeTable}>
      <Grid container spacing={2} >{props.children}</Grid>
    </div>
  );
};
